import { Component, OnInit } from '@angular/core';
import {ParameterService} from "../parameter.service";
import {JsonEditorModalComponent} from "../../json-editor-modal/json-editor-modal.component";
import {BaseComponent, IdTextValueModel, LeModalService} from "common-shared";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-parameter-list',
  templateUrl: './parameter-list.component.html',
  styles: [
  ]
})
export class ParameterListComponent extends BaseComponent implements OnInit {
  parameters$ = this.parameterService.getAll();

  constructor(private parameterService: ParameterService, private leModalService: LeModalService) {
    super();
  }

  ngOnInit(): void {
  }

  edit(parameter: IdTextValueModel) {
    let o = JSON.parse(parameter.Value ?? '{}');

    const modalRef = this.leModalService.show(JsonEditorModalComponent, {
      initialState: {
        title: parameter.Text,
        jsonContent: JSON.stringify(o, null, '\t'),
        hasSaveButtons: true,
        entityId: parameter.Id
      }, class: 'modal-lg'
    });

    modalRef.action.pipe(takeUntil(this.componentDestroyed)).subscribe((value: { action: string, data: any }) => {
      if (value.action === 'save') {
        parameter.Value = modalRef.content.jsonContent;
        this.parameterService.save(parameter).pipe(takeUntil(this.componentDestroyed)).subscribe(savedParameter => {
          parameter = savedParameter;
          if (value.data === true) {
            modalRef.content.close();
          }
        });
      }
    });
  }
}
